import React, { Fragment } from 'react'
import { Route } from 'react-router-dom';
import { CSVFile } from './Pages';

export const CSVFileRoutes = ({ match }) => (
    <Fragment>
        <Route exact path={`${match.path}`} component={CSVFile} />
    </Fragment>
)